export default __webpack_public_path__ + "static/media/card-aboutsec.a03003ac.png";